import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import App from './App';
import GuidancePage from './pages/GuidancePage';
import DashboardPage from './pages/DashboardPage';
import TopUkSchoolsGcseMap from './components/TopUkSchoolsGcseMap'; // renamed import
import Navbar from './components/Navbar';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Navbar />
    <Routes>
      <Route path="/" element={<TopUkSchoolsGcseMap />} /> {/* Set renamed map as homepage */}
      <Route path="/dashboard" element={<DashboardPage />} /> {/* Optional: dashboard at separate route */}
      <Route path="/upload" element={<App />} />
      <Route path="/guidance" element={<GuidancePage />} />
    </Routes>

    <footer role="contentinfo" className="w-full bg-gray-50 border-t border-gray-200 mt-10 py-6">
      <div className="max-w-7xl mx-auto px-4 flex flex-col items-center text-center text-sm text-gray-500">
        <p>
          © {new Date().getFullYear()} <span className="font-medium">Denis K</span> — Built with <span className="font-semibold">Java</span> & <span className="font-semibold">React</span>
        </p>
        <p className="mt-2">
          <a
            href="https://www.linkedin.com/in/denisvk-it/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            View on LinkedIn
          </a>
        </p>
      </div>
    </footer>
  </BrowserRouter>
);
